import React, { useEffect, useRef, useState } from "react";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { CircleSpinnerOverlay } from "react-spinner-overlay";
import { ThemeProvider, createTheme } from "@mui/material";
import MaterialTable from "material-table";
import { getApiCall, postFormApiCall } from "../../../utils/api";
import tableIcons from "../../component/MaterialIcon";
import Select from "react-select";

const SendSchoolNotification = () => {
  const defaultMaterialTheme = createTheme();
  const [selectedRow, setSelectedRow] = useState(null);
  const [loading, setLoading] = useState(false);

  const [message, setMessage] = useState("");
  const [data, setData] = useState([]);

  const [schoolOptions, setSchoolOptions] = useState([]);
  const ALL_OPTION = { value: -999, label: "All Schools" };
  const VARIABLE_CODES = [
    "{hasEmail}",
    "{hasName}",
    "{hasCoName}",
    "{hasPhone}",
    "{hasAddress}",
  ];
  const extractUsedVariables = (text) => {
    return VARIABLE_CODES.filter((code) => text.includes(code));
  };
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    const res = await getApiCall("school/notification/get/all");
    res.data.forEach((d, i) => (d.serial = i + 1));
    setData(res.data);

    const emailListRes = await getApiCall("get-all-school-email");

    setSchoolOptions([
      ALL_OPTION,
      ...emailListRes.data.map((option) => ({
        value: option.id,
        label: `${option.name} (${option.city})`,
      })),
    ]);
    setLoading(false);
  };

  const columns = [
    { title: "Sl. no", field: "serial" },
    { title: "School", field: "school_name" },
    { title: "Email", field: "email" },
    { title: "Message", field: "message" },
  ];
  const [emailVal, setEmailVal] = useState([]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const usedVariables = extractUsedVariables(message);

    const formData = new FormData();
    formData.append("message", message);
    formData.append("schoolIds", JSON.stringify(emailVal)); 
    formData.append("usedVariables", JSON.stringify(usedVariables)); 

    const res = await postFormApiCall("save-school-notification", formData);
    setLoading(false);

    if (res.error) {
      return Swal.fire("Error", res.message, "error");
    }

    Swal.fire("Success", res.message, "success");
    setMessage("");
    setSchoolOptions([]);
    setEmailVal([]);
    fetchData();
  };

  return (
    <>
      <CircleSpinnerOverlay loading={loading} />

      {/* Form */}
      <section className="content">
        <div className="container-fluid">
          <div className="card card-primary">
            <div className="card-header">
              <h3 className="card-title">Send Notification</h3>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="card-body row">
                <div className="col-md-12 mb-4">
                  <h5>Variable code and Meaning</h5>
                  {"{hasEmail}"} = email <br />
                  {"{hasName}"} = Name <br />
                  {"{hasCoName}"} = Coordinator Name <br />
                  {"{hasPhone}"} = Phone <br />
                  {"{hasAddress}"} = Address
                </div>

                <div className="col-md-6">
                  <label>Enter your message</label> <br />
                  <i style={{ fontSize: 13 }}>
                    Eg: Hi {"{hasEmail}"}, My address: {"{hasAddress}"}
                  </i>
                  <textarea
                    className="form-control"
                    placeholder="Example: Hi {hasEmail}, My address: {hasAddress}"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                    rows={5}
                  />
                </div>
                <div className="col-md-12 col-sm-12">
                  <div className="row">
                    <div className="col-md-6 col-sm-12">
                      <div class="form-group">
                        <label>Select Schools</label>
                        <Select
                          isMulti
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          styles={{
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          options={schoolOptions}
                          value={schoolOptions.filter((opt) =>
                            emailVal.includes(opt.value)
                          )}
                          onChange={(selectedOptions) => {
                            if (!selectedOptions) {
                              setEmailVal([]);
                              return;
                            }

                            const values = selectedOptions.map(
                              (opt) => opt.value
                            );

                            if (values.includes(-999)) {
                              setEmailVal([-999]);
                            } else {
                              setEmailVal(values);
                            }
                          }}
                          isOptionDisabled={(option) =>
                            emailVal.includes(-999) && option.value !== -999
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-footer">
                <button className="btn btn-primary">Save</button>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* Table */}
      <section className="content">
        <ThemeProvider theme={defaultMaterialTheme}>
          <MaterialTable
            icons={tableIcons}
            title="School Notifications"
            columns={columns}
            data={data}
            onRowClick={(e, row) => setSelectedRow(row.tableData.id)}
          />
        </ThemeProvider>
      </section>
    </>
  );
};

export default SendSchoolNotification;
